const BASE_LIST = 'https://raw.githubusercontent.com/pitzegluck/vars/main/base.tokenlist.json';

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [BASE_LIST];

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [BASE_LIST];
